import { RoutesDataType } from "../Interfaces/Config/Routes.interface";
import {
  ViewSafetyDocument,
  AllNotifiactions,
  Notification,
  ContactUserLogin,
  CommonLogin,
  UnAuthorized,
  Profile,
  Support,
  SitesReport,
  Search,
  RemindersDueToday,
  PageNotFound,
  RuleBuilder,
  ContactsReport,
  RuleRepository,
  SafetyDocumentReport,
  Home,
  SystemLogs,
  ConsolidatedReport
} from "../Routes";
import PrivilegesManagement from "../Routes/UserManagement/PrivilegesManagement/PrivilegesManagement";
import UserManagement from "../Routes/UserManagement/UserManagement";
import Workspace from "../Routes/Workspace/Workspace";

const routes: Array<RoutesDataType> = [
  {
    path: "*",
    element: <PageNotFound />,
  },
  {
    path: "/",
    element: <CommonLogin />,
  },
  {
    path: "/workspace",
    element: <Workspace />,
  },
  {
    path: "home",
    element: <Home />,
    sideMenu: true,
    header: true,
    privileges: ["0", "1", "2", "3", "20"],
  },
  {
    path: "si/login/:emailID",
    element: <ContactUserLogin />,
  },

  {
    path: "si/login",
    element: <ContactUserLogin />,
  },
  {
    path: "search",
    sideMenu: true,
    header: true,
    element: <Search />,
    privileges: ["3", "20"],
  },
  {
    path: "cumulative-raw-data-report",
    sideMenu: true,
    header: true,
    element: <ConsolidatedReport />,
    privileges: ["3", "20"],
  },
  {
    path: "reports/view/:reportId",
    sideMenu: true,
    header: true,
    element: <ViewSafetyDocument />,
  },
  {
    path: "reports/view/:reportId/:site",
    sideMenu: true,
    header: true,
    element: <ViewSafetyDocument />,
  },
  {
    path: "notifications",
    sideMenu: true,
    header: true,
    element: <AllNotifiactions />,
    privileges: ["5", "6"],
  },
  {
    path: "notification/:token",
    header: true,
    element: <Notification />,
    privileges: ["5", "6"],
  },
  {
    path: "notification/:token/:site", 
    header: true,
    element: <Notification />,
    privileges: ["5", "6"],
  },
  {
    path: "coming-soon",
    element: <UnAuthorized msg="Coming Soon" />,
  },
  {
    path: "unauthorized",
    element: <UnAuthorized msg="UnAuthorized" />,
  },
  {
    path: "safety-document",
    element: <SafetyDocumentReport />,
    sideMenu: true,
    header: true,
    privileges: ["3", "20"],
  },
  {
    path: "sites",
    element: <SitesReport />,
    sideMenu: true,
    header: true,
    privileges: ["3", "20"],
  },
  {
    path: "auditlog",
    element: <SystemLogs />,
    sideMenu: true,
    header: true,
    privileges: ["7", "20"],
  },
  {
    path: "contact-compliance",
    element: <ContactsReport />,
    sideMenu: true,
    header: true,
    privileges: ["3", "20"],
  },
  {
    path: "profile",
    sideMenu: true,
    header: true,
    element: <Profile />,
    privileges: ["0", "1", "2", "3", "5", "6", "7", "8", "9", "10", "11", "20"],
  },
  {
    path: "support",
    sideMenu: true,
    header: true,
    element: <Support />,
    privileges: ["0", "1", "2", "3", "5", "6", "7", "8", "9", "10", "11", "20"],
  },
  {
    path: "reminders-due",
    sideMenu: true,
    header: true,
    element: <RemindersDueToday />,
    privileges: ["0", "1", "2", "3", "5", "6", "7", "8", "9", "10", "11", "20"],
  },
  {
    path: "reporting-rules",
    element: <RuleRepository />,
    sideMenu: true,
    header: true,
    privileges: ["10", "11", "20"],
  },
  {
    path: "rule-builder",
    element: <RuleBuilder />,
    sideMenu: true,
    header: true,
    privileges: ["10", "11", "20"],
  },
  {
    path: "rule-builder/:ruleId",
    element: <RuleBuilder />,
    sideMenu: true,
    header: true,
    privileges: ["10", "11", "20"],
  },
  {
    path: "/user-management/:type",
    element: <UserManagement />,
    sideMenu: true,
    header: true,
    privileges: ["9", "20"],
  },
  {
    path: "/privileges",
    element: <PrivilegesManagement />,
    sideMenu: true,
    header: true,
    privileges: ["9", "20"],
  },
  // {
  //   path: "/pdf-report-builder",
  //   element: <PdfReportBuilder />,
  // },
];

export default routes;
